var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { revokedBadgeReasonsClassifierEntityName, } from '../../../../backend/config/classifiers/revoked-badge-reasons-classifier/types';
import { accountBadgeEntityName, logBadgeHistoryActionFunctionDef, } from '../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { handleErrorSnackbar, showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
import { revokeBadgeFormConfig } from '../forms/revokeBadgeForm';
export function useAccountBadgeRevokeAction({ accountBadge, onActionSuccess }) {
    const { t } = useBadgingTranslation();
    const logBadgeHistoryAction = useTypedPlatformFunction(logBadgeHistoryActionFunctionDef);
    const accountBadgeStorage = useStorageClient(accountBadgeEntityName);
    const revokedBadgeReasonsStorage = useStorageClient(revokedBadgeReasonsClassifierEntityName);
    const handleAccountBadgeRevoke = (actionOptions) => {
        if (!accountBadge) {
            return;
        }
        showFormDialog({
            title: t('badges.badgeDetails.accountBadgeTable.menuItems.revoke.modalTitle', {
                name: accountBadge.columns.accountDisplayName,
            }),
            config: revokeBadgeFormConfig(t),
            submitLabel: t('badges.badgeDetails.accountBadgeTable.actions.revoke'),
            onSubmit: (data) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                try {
                    const revokedBadgeReasonsData = yield revokedBadgeReasonsStorage.get(data.revokedBadgeReasonsClassifierId);
                    yield accountBadgeStorage.post({
                        action: 'partial-update',
                        id: accountBadge.id,
                        data: {
                            status: 'revoked',
                            statusReason: {
                                title: revokedBadgeReasonsData.data.title,
                                description: data.revokeReasonDescription || revokedBadgeReasonsData.data.description,
                                canReissue: revokedBadgeReasonsData.data.canReissue,
                            },
                        },
                    });
                    yield logBadgeHistoryAction({
                        note: data.revokeReasonDescription || revokedBadgeReasonsData.data.description,
                        accountBadgeIds: [accountBadge.id],
                        badgeId: accountBadge.columns.badgeId,
                        action: 'accountBadgeRevoked',
                    });
                }
                catch (error) {
                    handleErrorSnackbar(error);
                }
                finally {
                    const onSuccessFn = (_a = actionOptions === null || actionOptions === void 0 ? void 0 : actionOptions.onActionSuccess) !== null && _a !== void 0 ? _a : onActionSuccess;
                    void onSuccessFn();
                    showAlertSnackbar({
                        horizontalPosition: 'center',
                        type: 'success',
                        verticalPosition: 'bottom',
                        autoHideDuration: 2000,
                        message: t('badges.badgeList.editDialog.successMessage'),
                    });
                }
            }),
        });
    };
    return {
        handleAccountBadgeRevoke,
    };
}
